import { CloseIcon, MenuIcon } from 'components/Icon'
import { useBoolean, useClickOutside } from 'hooks'
import { useRef } from 'react'
import { Box, Flex } from 'theme-ui'

export type NavMenuProps = {
  Content: JSX.Element
  Footer?: JSX.Element
}

export const NavMenu = ({ Content, Footer }: NavMenuProps) => {
  const menuRef = useRef<HTMLDivElement>(null)
  const [open, , close, toggle] = useBoolean(false)
  useClickOutside(menuRef, close)
  return (
    <Flex
      sx={{
        pl: [30, 40],
        pr: [20, 25],
        alignItems: 'center',
      }}
      ref={menuRef}>
      <Box
        sx={{
          height: 'auto',
          position: ['unset', 'relative'],
        }}>
        <MenuIcon
          onClick={toggle}
          data-cy="nav-menu-btn"
          data-testid="nav-menu-btn"
          sx={{ cursor: 'pointer' }}
        />
        <Flex
          role="menu"
          data-testid="nav-menu"
          style={{
            visibility: open ? 'visible' : 'hidden',
            opacity: open ? 1 : 0,
            pointerEvents: open ? 'initial' : 'none',
            transform: open ? 'scale(1)' : 'scale(0.9)',
          }}
          sx={{
            position: 'absolute',
            flexDirection: 'column',
            borderRadius: 4,
            boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.1)',
            bg: 'white',
            zIndex: 999,
            transformOrigin: 'top center',
            transition: '300ms ease-in-out',
            textAlign: 'left',
            right: 0,
            minWidth: 272,
            top: [0, 24],
            justifyContent: 'space-between',
            height: ['100vh', 437],
            p: 30,
          }}>
          <Box
            sx={{
              position: 'absolute',
              width: 24,
              height: 24,
              top: 3,
              right: 3,
              bg: 'white',
              cursor: 'pointer',
              justifyContent: 'center',
              alignItems: 'center',
              display: ['block', 'none'],
            }}
            onClick={close}>
            <CloseIcon size={16} />
          </Box>
          <Box>{Content}</Box>
          <Box>{Footer}</Box>
        </Flex>
      </Box>
    </Flex>
  )
}
